export const form = {
  email: {
    label: 'E -posta',
    placeholder: 'Postanın adresini girin'
  },
  name: {
    label: 'İsim',
    placeholder: 'Adı girin'
  },
  clubName: {
    label: 'Kulübün adı',
    placeholder: 'Kulübün adını girin',
    description: 'Latince adını girin'
  },
  address: {
    label: 'Adres',
    placeholder: 'Adresi girin'
  },
  workPeriod: {
    start: {
      placeholder: 'İşin başlangıcı'
    },
    end: {
      placeholder: 'İşin sonu'
    }
  },
  workTime: {
    start: {
      label: 'Açılış saati'
    },
    end: {
      label: 'Kapanış Süresi'
    }
  },
  country: {
    label: 'Kulübün yerini belirtin',
    placeholder: 'Kulübün yerini belirtin'
  },
  role: {
    label: 'Kulüpteki boş pozisyonlar'
  },
  currency: {
    label: 'Sanatçılara yapılan ödemelerin para birimini belirtin',
    placeholder: 'Sanatçılara yapılan ödemelerin para birimini belirtin'
  },
  nativeLanguage: {
    label: 'Ana dil',
    placeholder: 'Ana dilinizi belirtin'
  },
  lastName: {
    label: 'Soyadı',
    placeholder: 'Soyadınızı Girin'
  },
  birth: {
    label: 'Doğum tarihi',
    placeholder: 'Doğum tarihini girin'
  },
  password: {
    label: 'Şifre',
    placeholder: 'Şifreyi girin',
    description:
      'Parola, üst ve alt sicilin en az 8 karakter, sayılar ve özel karakterler içermelidir (örneğin,!, @, #, $)'
  },
  resetPassword: {
    new: {
      label: 'Yeni Şifre',
      placeholder: 'Yeni bir şifre girin'
    },
    confirm: {
      label: 'Şifreyi onaylayın',
      placeholder: 'Yeni bir şifre girin'
    }
  },
  penalties: {
    placeholder: 'Para cezasının adını girin'
  },
  phone: {
    label: 'Telefon numarası',
    placeholder: '+373-000-00-00'
  },
  buttons: {
    continue: 'Devam etmek',
    login: 'Giriş',
    send: 'Göndermek',
    cancel: 'İptal etmek',
    confirm: 'Onaylamak',
    resend: 'Tekrar gönder',
    register: 'Kayıt olmak',
    registerRequest: 'Kayıt için bir başvuru bırakın'
  },
  links: {
    forgotPasswordLink: 'Şifreyi mi unuttunuz?',
    login: 'Girmek',
    haveAccount: 'Zaten bir hesabım var',
    privacy: 'Kullanıcı Sözleşmesi ve Gizlilik Politikası.'
  },
  other: {
    or: 'Veya'
  },
  approximateStartDate: {
    label: 'Yaklaşık çalışma tarihi'
  },
  approximateEndDate: {
    label: 'Yaklaşık iş sonu tarihi'
  },
  search: {
    placeholder: 'Aramak',
    placeholderCitizienship: 'Vatandaşlık arayın'
  },
  positionItem: {
    label: 'Bir pozisyona girin'
  },
  paymentFrequency: {
    label: 'Ödemelerin sıklığı'
  },
  price: {
    label: 'Fiyat'
  },
  priceForArtist: {
    label: 'Sanatçıya Toplam'
  },
  artistPercent: {
    label: 'Sanatçının yüzdesi'
  }
};
